import React, { useCallback, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import JobsList from '../components/jobslist/JobsList';
import PastJobsList from '../components/jobslist/PastJobsList';
import { useCustomRouter } from '../utils/hooks/useCustomRouter';
import JobsPage from './JobsPage';

export enum JobType {
    CURRENT = 'current',
    PAST = 'past',
}

const Jobs: React.FC = () => {
    const router = useCustomRouter();
    const location = useLocation();
    const pastJobURL = !!matchPath(location.pathname, {
        path: '/past-jobs',
        exact: true,
        strict: false,
    });
    const [isPastJob] = useState<boolean>(pastJobURL);

    const onCurrentJobsHandler = useCallback(() => {
        isPastJob
            ? router.push('/', 'none', 'pop')
            : router.push('/past-jobs', 'none', 'pop');
    }, [isPastJob, router]);

    return (
        <JobsPage
            jobType={isPastJob ? JobType.PAST : JobType.CURRENT}
            onJobTypeHandler={onCurrentJobsHandler}
        >
            {isPastJob ? <PastJobsList /> : <JobsList />}
        </JobsPage>
    );
};

export default Jobs;
